import React from 'react';
import { TableHeadersType } from '../../../../../constant/tableHeadersConstants/tableHeadersType';
import { TableHeader, TableLoader } from '../../../../commons';
import StockItemTableData from './StockItemTableData';
import ScrollToTop from '../../../../commons/ScrollToTop';
import InfiniteLoader from '../../../../commons/InfiniteLoader/InfiniteLoader';

type AppProps = {
  data: any[];
  headers: TableHeadersType[];
  fetching: boolean;
  company_name: string | null;
  client_code: number | undefined;
  handleEditStockItemDetails: (data: any) => void;
  isEditStockItemPresent: boolean;
  offset: number;

}

const StockItemListTable = ({
  data,
  headers,
  fetching,
  company_name,
  client_code,
  handleEditStockItemDetails,
  isEditStockItemPresent,
  offset,

}: AppProps) => {

  return (
    <>
        <div className="jobsType">
          <table className="table table-bordered thead-light">
            <thead className='text-start sticky-table-header'>
              <TableHeader
                tableHeader={headers}
                extraHeader
              />
            </thead>
            <tbody>
              <StockItemTableData
                company_name={company_name}
                client_code={client_code}
                tableHeaders={headers}
                data={data}
                handleEditStockItemDetails={handleEditStockItemDetails}
                isEditStockItemPresent={isEditStockItemPresent}
              />
            {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
            <div style={{ display: fetching ? "none" : "inline" }}>
            <ScrollToTop />
          </div>
            </tbody>
          </table>
        </div>
    </>
  )
}

export default StockItemListTable;